<template>
  <div class="tva-video-lazy">
    <LazyVideo
      :src="`${baseUrl}${content.src}`"
      :poster="`${baseUrl}${content.poster}`"
    />
  </div>
</template>
<script>
export default {
  props: ["content"],
  data() {
    return {
      baseUrl: process.env.BASE_URL
    };
  }
};
</script>
<style lang="scss" scoped>
.tva-video-lazy {
  width: 100%;
  video {
    width: 100%;
  }
}
</style>
